import { render, staticRenderFns } from "./IndustryTalent.vue?vue&type=template&id=cc3f9266"
import script from "./IndustryTalent.vue?vue&type=script&lang=js"
export * from "./IndustryTalent.vue?vue&type=script&lang=js"
import style0 from "./IndustryTalent.vue?vue&type=style&index=0&id=cc3f9266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports